<template>
  <v-app style="height: 100%">
    <v-container class="containerLanding">
      <div style="height: 30%; text-align: center;">
        <v-img src="/logo-big-dark.png" class="imgLogoDark" />
        <h1>
          {{ $t('LandingPage.WelcomeMessage1') }}
        </h1>
        <h4>{{ $t('LandingPage.WelcomeMessage2') }}</h4>
      </div>
      <div class="waveLanding">
        <svg viewBox="0 0 500 200" style="background-color: transparent">
          <path
            d="M0, 180 C0, 100 400,
                -10 550, 100 L500, 00 L0, 0 Z"
          />
        </svg>
        <p class="center started">
          {{ $t('LandingPage.Start') }}
        </p>
        <v-btn class="btn-white buttonLanding" style="color: #00E3B4;" @click="goLogin">
          {{ $t('LOG IN') }}
        </v-btn>
        <p class="center noAccount">
          {{ $t('LandingPage.NoAccount') }}
        </p>
        <v-btn class=" buttonLanding" text style="color: #FFFFFF; border: 2px solid white;border-radius: 15px;" @click="goRegister">
          {{ $t('SIGN UP') }}
        </v-btn>
      </div>
      <v-dialog transition="dialog-bottom-transition" max-width="600px">
        <template v-slot:activator="{ on }">
          <v-icon style="position: absolute; top: 10px; right: 20px;" v-on="on">
            mdi-earth
          </v-icon>
        </template>
        <template v-slot:default="dialog">
          <v-card class="dialogResetLanguage" dark>
            <h3 class="title-center-dialog">
              <br>{{ $t('Login.LanguageTitle') }}
            </h3>
            <v-card-text>
              <v-list color="primary" dark>
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  @click="changeLanguage(item.title)"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>
      <v-footer color="base" app style=" height:5%;background-color: #FFFFFF; font-size: 14px; position: absolute; padding: 20px 6px 6px">
        <h5>Byppay 2023 &copy;</h5>
        <h5 class="pointer" @click="privacyPolicy">
          {{ $t('|Policies') }}
        </h5>
        <v-spacer />
      </v-footer>
    </v-container>
  </v-app>
</template>

<script>

import LocalRepository from "../repositories/LocalRepository";
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";

export default {
    name: 'LandingLayout',
    components: { },
    data () {
        return {
            darkMode: false,
            items: [
                { title: this.$t('Catalan') },
                { title: this.$t('Spanish') },
                { title: this.$t('English') },
            ]
        };
    },
    computed: {
        theme () {
            return (this.$vuetify.theme.dark) ? 'dark' : 'light';
        }
    },
    watch: {
        darkMode: function (newVal) {
            this.$vuetify.theme.dark = newVal;
            LocalRepository.set('dark', {dark: newVal});
            if (newVal) {
                document.body.classList.add("dark");
            } else {
                document.body.classList.remove("dark");
            }
        },
    },
    created () {
        const initialDark = LocalRepository.get('dark');
        if (initialDark) {
            this.$data.darkMode = initialDark.dark;
        }

        document.body.classList.remove("dark"); //desactivem dark mode que produeix la no visualització de moltes coses
    },
    methods: {
        goLogin () {
            this.$router.push({name: 'Login', replace: false});
        },
        privacyPolicy () {
            this.$router.push({name: 'PrivacyPolicy', replace: false});
        },
        goRegister () {
            this.$router.push({name: 'Register', replace: false});
        },
        changeLanguage (lang) {
            let language = '';
            if (lang === 'Catalan' || lang === 'Català' || lang === 'Catalán') language = 'ca';
            if (lang === 'Spanish' || lang === 'Castellà' || lang === 'Español') language = 'es';
            if (lang === 'English' || lang === 'Anglès' || lang === 'Inglés') language = 'en';
            ApiRepository.changeLanguage(language)
                .then(() => { })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing language'), color: 'error'});
                    console.error(err);
                });
            localStorage.setItem('language', language);
            location.reload();
        },
    },
};
</script>

<style scoped>
  .titol{
    color: #000000;
    font-family: Montserrat, sans-serif;
    font-size: large;
  }
  .containerLanding{
    height: 100%;
    padding: 2px 0;
    background: #FFFFFF
  }
  .imgLogoDark {
    width: 10vh;
    margin-left: auto;
    margin-right: auto;
    margin-top: 8%
  }
  .waveLanding {
    height: 70%;
    text-align: center;
    background: linear-gradient(180deg, #0AE7C1 8.33%, #128AFA 100%);
  }
  svg {
    position: relative;
    width: 100%;
    fill: #FFFFFF;
  }
  .buttonLanding {

    margin: 5px 0;
    font-size: xx-large;
    font-family: "Montserrat",serif;
  }
  .started{
    font-size: large;
    font-family: "Montserrat",serif;
    font-style: normal;
    margin-bottom: 0;
    margin-top: 0;
  }
  .noAccount{
    margin-top: 15px;
    font-size: small;
    font-family: "Montserrat",serif;
  }
  .dialogResetLanguage{
    position: absolute;
    margin: auto;
    border-top-left-radius: 70px;
    border-top-right-radius: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 600px;
    height: 40%;
    text-align: center;
    background: rgba(67, 225, 178, 0.95);
  }
</style>
